import Button from "app/components/Button";
import Progress from "app/components/Progress";
import { FormElement } from "app/types";
import leftArrow from "assets/svgs/ic_left_caret.svg";
import rightArrow from "assets/svgs/ic_right_caret.svg";
import React from "react";

export interface IStageOptions {
  options: {
    _id: string;
    name: string;
    icon: string;
  }[];
  title: string;
  type: string;
  className: string;
  value: FormElement | string | string[];
  onChange: (option: string | string[]) => void;
}

interface Props {
  currentStage: number;
  STAGES: IStageOptions[];
  handleBack: () => void;
  handleSave: () => void;
  handleNext: () => void;
  isNextDisabled: () => boolean;
  isLoading: boolean;
  isDisabled: boolean;
}
const BottomSection: React.FC<Props> = ({
  currentStage,
  STAGES,
  handleBack,
  handleSave,
  handleNext,
  isNextDisabled,
  isLoading,
  isDisabled,
}) => {
  return (
    <div className="container max-w-screen-xl mx-auto gap-[50px] flex flex-col px-8">
      <Progress
        progress={((currentStage + 1) * 100) / STAGES.length}
        progressClassName=" bg-[linear-gradient(150.34deg,#65ACFF_11.7%,#8ADCE2_81.94%)]  "
      />
      <div className="flex flex-row items-center justify-between">
        <Button
          disabled={currentStage === 0}
          disabledClassName="opacity-50"
          onClick={handleBack}
          className="border w-[110px] h-[52px] border-secondary bg-white text-secondary flex items-center justify-center gap-[6px]"
        >
          <span>
            <img src={leftArrow} sizes="24px" alt="Back" />
          </span>
          <span>Back</span>
        </Button>
        {currentStage === STAGES.length - 1 ? (
          <></>
        ) : (
          <Button
            onClick={handleNext}
            disabled={isNextDisabled()}
            disabledClassName="opacity-50"
            className="border w-[110px] h-[52px] border-secondary bg-white text-secondary flex items-center justify-center gap-[6px]"
          >
            <span>Next</span>
            <span>
              <img src={rightArrow} sizes="24px" alt="Next" />
            </span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default BottomSection;
